import React, { useState, useEffect } from 'react';
import grantService from '../services/grantService';
import './SearchForm.css';

const SearchForm = ({ onSearch }) => {
  const [searchParams, setSearchParams] = useState({
    organizationName: '',
    fiscalYear: 'all',
    minAmount: '',
    maxAmount: '',
    agencyDept: 'all'
  });

  const [fiscalYears, setFiscalYears] = useState(['all']);
  const [agencies, setAgencies] = useState(['all']);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Load filter options when component mounts
    const loadFilterOptions = async () => {
      try {
        const years = await grantService.getFiscalYears();
        const agencyList = await grantService.getAgencies();

        setFiscalYears(['all', ...years]);
        setAgencies(['all', ...agencyList]);
      } catch (error) {
        console.error('Error loading filter options:', error);
      }
    };

    loadFilterOptions();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Call the parent component's onSearch function
      await onSearch(searchParams);
    } catch (error) {
      console.error('Error searching grants:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="search-form card">
      <h2>Search California Grants</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="organizationName">Organization Name</label>
          <input
            type="text"
            id="organizationName"
            name="organizationName"
            value={searchParams.organizationName}
            onChange={handleInputChange}
            placeholder="Enter organization name"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="fiscalYear">Fiscal Year</label>
            <select
              id="fiscalYear"
              name="fiscalYear"
              value={searchParams.fiscalYear}
              onChange={handleInputChange}
            >
              {fiscalYears.map(year => (
                <option key={year} value={year}>{year === 'all' ? 'All Years' : year}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="agencyDept">Agency/Department</label>
            <select
              id="agencyDept"
              name="agencyDept"
              value={searchParams.agencyDept}
              onChange={handleInputChange}
            >
              {agencies.map(agency => (
                <option key={agency} value={agency}>{agency === 'all' ? 'All Agencies' : agency}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="minAmount">Min Amount ($)</label>
            <input
              type="number"
              id="minAmount"
              name="minAmount"
              value={searchParams.minAmount}
              onChange={handleInputChange}
              placeholder="Minimum"
            />
          </div>

          <div className="form-group">
            <label htmlFor="maxAmount">Max Amount ($)</label>
            <input
              type="number"
              id="maxAmount"
              name="maxAmount"
              value={searchParams.maxAmount}
              onChange={handleInputChange}
              placeholder="Maximum"
            />
          </div>
        </div>

        <button type="submit" className="button" disabled={isLoading}>
          {isLoading ? 'Searching...' : 'Search Grants'}
        </button>
      </form>
    </div>
  );
};

export default SearchForm;